import React from 'react';

function CurrentDate(props) {
  const {newdate}=props;
  const date = newdate;
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thurs', 'Fri', 'Sat'];
  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const day = days[date.getDay()];
  const month = months[date.getMonth()];
  const year = date.getFullYear();

  return (
    <div className='date-container'>
      {day} {month} {date.getDate()}, {year}
    </div>
  );
}

export default CurrentDate;
